import "./Background.css";

export default function BackgroundAnimation() {
  return (
    <div className="background">
      <div className="circle circle1"></div>
      <div className="circle circle2"></div>
      <div className="circle circle3"></div>
    </div>
  );
}
